module.exports = [{"id":0,"name":"冰魄碎片X2","imgUrl":"./static/images/barrage/17000sjjj.png"},{"id":1,"name":"2222222222","imgUrl":"./static/images/barrage/17000sjjj.png"},{"id":2,"name":"eeeeeeeeeee2222222","imgUrl":"./static/images/barrage/17000sjjj.png"},{"id":3,"name":"ew","imgUrl":"./static/images/barrage/17000sjjj.png"},{"id":4,"name":"aaaaaaaa","imgUrl":"./static/images/barrage/17000sjjj.png"}]


//////////////////
// WEBPACK FOOTER
// ./src/api/record.json
// module id = fA0x
// module chunks = 1